/**
 * Created by Federico Brocco on 13/05/2022.
 *
 * @format
 */

/**
 * Recupera l'elenco dei ticket per l'utente autenticato
 * @returns {Promise<Array>} Promise che risolve con un array di ticket
 */
let list = function () {
    return new Promise(function (resolve, reject) {

        const hash = localStorage.getItem('hash');
        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        fetch(window.route.ticket, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API ticket', responseJson);
                resolve(responseJson.tickets);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

/**
 * Apre un nuovo ticket con le informazioni fornite
 * @param {Object} ticket - I dati del ticket da aprire
 * @param {string|number} ticket.id_category - L'ID della categoria del ticket
 * @param {string} ticket.object - L'oggetto/titolo del ticket
 * @returns {Promise<Object>} Promise che risolve con i dati del ticket aperto
 */
let openTicket = function (ticket) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');
        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        fetch(window.route.ticketBooking, {
            headers: {'x-access-token': hash},
            method: 'POST',
            body: JSON.stringify({
                id_category : ticket.id_category,
                object_: ticket.object
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API openTicket', responseJson);
                resolve(responseJson.ticket);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};


/**
 * Recupera tutti i messaggi associati a un ticket specifico
 * @param {string|number} id - L'ID del ticket
 * @returns {Promise<Array>} Promise che risolve con un array di messaggi del ticket
 */
let messages = function (id) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');
        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        fetch(window.route.messageTicket + "?ticket_id=" + id, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API ticket messages', responseJson.messages);
                resolve(responseJson.messages);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

/**
 * Invia un messaggio a un ticket esistente, con possibilità di allegare un file
 * @param {Object} ticket - I dati del ticket e del messaggio
 * @param {string|number} ticket.id - L'ID del ticket
 * @param {string} ticket.message - Il testo del messaggio da inviare
 * @param {Object|null} attachment - L'allegato opzionale
 * @param {string} attachment.name - Il nome del file allegato
 * @param {string} attachment.file - Il file codificato in base64
 * @returns {Promise<Object>} Promise che risolve con i dati del messaggio inviato
 */
let sendMessage = function (ticket, attachment) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');
        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        fetch(window.route.bookingMessageTicket, {
            headers: {'x-access-token': hash},
            method: 'POST',
            body: JSON.stringify({
                ticket_id : ticket.id,
                message: ticket.message,
                name_file_uploaded: (attachment !== null) ? attachment.name : undefined,
                file_uploaded: (attachment !== null) ? attachment.file : undefined,
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API sendMessage', responseJson);
                resolve(responseJson.message);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

const TicketAPI = {
    list: list,
    openTicket: openTicket,
    messages: messages,
    sendMessage: sendMessage
};

export default TicketAPI;
